import { FadeUp, Eyebrow } from "@/lib/motion";

const STEPS = [
  {
    n: "01",
    title: "Discover & Audit",
    body: "We map every gap across your website, search presence, and ad spend — and show you what each one costs you.",
    tag: "Week one",
    tagColor: "bg-[#FEF9C3] border-[#FACC15] text-[#713F12]",
  },
  {
    n: "02",
    title: "Strategy & Roadmap",
    body: "A plain-language plan: what we fix first, why it pays, and what success looks like 90 days out.",
    tag: "The plan",
    tagColor: "bg-[#FFEDD5] border-[#FB923C] text-[#9A3412]",
  },
  {
    n: "03",
    title: "Design & Build",
    body: "Senior specialists rebuild your pages for speed, clarity, and conversion — 1:1 with Todd throughout.",
    tag: "The build",
    tagColor: "bg-[#CCFBF1] border-[#14B8A6] text-[#115E59]",
  },
  {
    n: "04",
    title: "Optimize & Rank",
    body: "SEO, Google Business Profile, and remarketing tuned until the right searches find you first.",
    tag: "The climb",
    tagColor: "bg-[#FEE2E2] border-[#EF4444] text-[#991B1B]",
  },
  {
    n: "05",
    title: "Launch & Measure",
    body: "Everything ships tracked. Calls, forms, and rankings in one honest report — no vanity numbers.",
    tag: "The proof",
    tagColor: "bg-flame/10 border-flame/40 text-flame",
  },
  {
    n: "06",
    title: "Repair, Report, Repeat",
    body: "Quarterly Cross-Web checkups keep the gaps closed while your compound results keep growing.",
    tag: "The habit",
    tagColor: "bg-slate-100 border-slate-300 text-slate-700",
  },
];

export default function ProcessSteps() {
  return (
    <section
      data-testid="process-section"
      className="bg-[#F8F9FA] py-16 md:py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <FadeUp>
          <Eyebrow>How we work</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            From first audit to always-on growth
          </h2>
        </FadeUp>
        <div className="mt-14 grid gap-4 lg:grid-cols-2 lg:gap-6">
          {STEPS.map((step, i) => (
            <FadeUp key={step.n} delay={(i % 2) * 0.08} className="h-full">
              <div className="group flex h-full gap-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:border-flame/40 hover:shadow-md sm:p-8">
                <span
                  aria-hidden="true"
                  className="select-none font-mono text-5xl font-bold leading-none text-slate-200 transition-colors duration-300 group-hover:text-flame/40 sm:text-6xl lg:text-7xl"
                >
                  {step.n}
                </span>
                <div>
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="font-display text-xl font-bold text-slate-900 sm:text-2xl">
                      {step.title}
                    </h3>
                    <span
                      className={`rounded-full border px-3 py-1 font-mono text-[13px] uppercase tracking-[0.15em] ${step.tagColor}`}
                    >
                      {step.tag}
                    </span>
                  </div>
                  <p className="mt-3 text-lg leading-relaxed text-slate-800">
                    {step.body}
                  </p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
